<i class="fa-heart favourite-icon" [ngClass]="isFavourite ? 'fa-solid' : 'fa-regular'"></i>
